import type { FaireProductEntity } from "../../entity_types/product";

export const p_5dyrqvwypm: FaireProductEntity = {
  token: "p_5dyrqvwypm",
  type: "product",
  name: "Peanut Butter Chocolate Fudge, 2.25 oz.",
  brandToken: "b_f0wtyxk4dn",
  brandName: "Chesebro's Handmade Confections and Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/e444d6fb8b073db600e24a13fe24d0aee6a0470d45a063fe5ac2bf7faa763875.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/52f83c7e93f6206c5df40df52a169cc6cc33532c6fd1e9b662b29143ef572a6d.png",
    "https://cdn.faire.com/fastly/2dcbb92d6e8c273bd95d3d2df07d8ad3c1ac1eb2cdbba10ca8ae4ce0ce98eb8f.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "We cook our fudge using premium ingredients, including Ghirardelli chocolate and creamy peanut butter and then hand pour it into individual 2.25 ounce cups that are a perfect size to share with a friend or keep all for your self!  Each fudge cup is individually sealed in a plastic bag with header, extending the shelf life to up to 12 weeks and also making it easy to gift.\n\nAll of our candy is cooked in a copper kettle with top quality ingredients before being formed by hand or with vintage equipment.\n\nWe're proud to say our candies are family made in the USA!\n\nManufactured in a commercial facility that processes tree nuts, peanuts, dairy and soy products. Please do not eat if you have allergies to these products.",
  tags: [],
  msrpDollars: 8.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:44.649Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
